import React, { useCallback } from 'react'
import { HtmlEditor } from 'scenes/Dashboard/components/HtmlEditor'
import { HtmlEditorProps } from 'scenes/Dashboard/components/HtmlEditor/HtmlEditor.presentational'
import { FieldProps } from 'utils-next/forms'

export type HtmlEditorFieldProps = HtmlEditorProps & FieldProps

export function HtmlEditorField({ field, form: { setFieldValue }, ...props }: HtmlEditorFieldProps) {
  const handleChange = useCallback((value: any) => setFieldValue(field.name, value), [field.name, setFieldValue])
  return <HtmlEditor {...field} {...props} onChange={handleChange} />
}
